import { type ComponentPropsWithRef, memo } from 'react';

export const IconHistory = memo<ComponentPropsWithRef<'svg'>>((props) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 1.25C8.41421 1.25 8.75 1.58579 8.75 2V5C8.75 5.41421 8.41421 5.75 8 5.75C7.58579 5.75 7.25 5.41421 7.25 5V2C7.25 1.58579 7.58579 1.25 8 1.25Z"
			fill="#111111"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 1.25C16.4142 1.25 16.75 1.58579 16.75 2V5C16.75 5.41421 16.4142 5.75 16 5.75C15.5858 5.75 15.25 5.41421 15.25 5V2C15.25 1.58579 15.5858 1.25 16 1.25Z"
			fill="#111111"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.2 15.75C16.8469 15.75 15.75 16.8469 15.75 18.2C15.75 19.5531 16.8469 20.65 18.2 20.65C19.5531 20.65 20.65 19.5531 20.65 18.2C20.65 16.8469 19.5531 15.75 18.2 15.75ZM14.25 18.2C14.25 16.0185 16.0185 14.25 18.2 14.25C20.3815 14.25 22.15 16.0185 22.15 18.2C22.15 20.3815 20.3815 22.15 18.2 22.15C16.0185 22.15 14.25 20.3815 14.25 18.2Z"
			fill="#111111"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20.4697 20.4697C20.7626 20.1768 21.2374 20.1768 21.5303 20.4697L22.5303 21.4697C22.8232 21.7626 22.8232 22.2374 22.5303 22.5303C22.2374 22.8232 21.7626 22.8232 21.4697 22.5303L20.4697 21.5303C20.1768 21.2374 20.1768 20.7626 20.4697 20.4697Z"
			fill="#111111"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.75 9.08984C2.75 8.67563 3.08579 8.33984 3.5 8.33984H20.5C20.9142 8.33984 21.25 8.67563 21.25 9.08984C21.25 9.50406 20.9142 9.83984 20.5 9.83984H3.5C3.08579 9.83984 2.75 9.50406 2.75 9.08984Z"
			fill="#111111"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.7371 5.38534C4.09637 6.07535 3.75 7.11497 3.75 8.5V17C3.75 18.385 4.09637 19.4246 4.7371 20.1147C5.36848 20.7946 6.39295 21.25 8 21.25H13.37C13.7842 21.25 14.12 21.5858 14.12 22C14.12 22.4142 13.7842 22.75 13.37 22.75H8C6.10705 22.75 4.63152 22.2054 3.6379 21.1353C2.65363 20.0754 2.25 18.615 2.25 17V8.5C2.25 6.88503 2.65363 5.42465 3.6379 4.36466C4.63152 3.29462 6.10705 2.75 8 2.75H16C17.893 2.75 19.3685 3.29462 20.3621 4.36466C21.3464 5.42465 21.75 6.88503 21.75 8.5V13C21.75 13.4142 21.4142 13.75 21 13.75C20.5858 13.75 20.25 13.4142 20.25 13V8.5C20.25 7.11497 19.9036 6.07535 19.2629 5.38534C18.6315 4.70538 17.607 4.25 16 4.25H8C6.39295 4.25 5.36848 4.70538 4.7371 5.38534Z"
			fill="#111111"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.9955 13.7002C10.9955 13.1479 11.4432 12.7002 11.9955 12.7002H12.0045C12.5568 12.7002 13.0045 13.1479 13.0045 13.7002C13.0045 14.2525 12.5568 14.7002 12.0045 14.7002H11.9955C11.4432 14.7002 10.9955 14.2525 10.9955 13.7002Z"
			fill="#111111"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.29431 13.7002C7.29431 13.1479 7.74203 12.7002 8.29431 12.7002H8.30329C8.85558 12.7002 9.30329 13.1479 9.30329 13.7002C9.30329 14.2525 8.85558 14.7002 8.30329 14.7002H8.29431C7.74203 14.7002 7.29431 14.2525 7.29431 13.7002Z"
			fill="#111111"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.29431 16.7002C7.29431 16.1479 7.74203 15.7002 8.29431 15.7002H8.30329C8.85558 15.7002 9.30329 16.1479 9.30329 16.7002C9.30329 17.2525 8.85558 17.7002 8.30329 17.7002H8.29431C7.74203 17.7002 7.29431 17.2525 7.29431 16.7002Z"
			fill="#111111"
		/>
	</svg>
));

export const IconHistoryActive = (props: ComponentPropsWithRef<'svg'>) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M16.75 3.56V2C16.75 1.59 16.41 1.25 16 1.25C15.59 1.25 15.25 1.59 15.25 2V3.5H8.74999V2C8.74999 1.59 8.40999 1.25 7.99999 1.25C7.58999 1.25 7.24999 1.59 7.24999 2V3.56C4.54999 3.81 3.23999 5.42 3.03999 7.81C3.01999 8.1 3.25999 8.34 3.53999 8.34H20.46C20.75 8.34 20.99 8.09 20.96 7.81C20.76 5.42 19.45 3.81 16.75 3.56Z"
			fill="#111111"
		/>
		<path
			d="M20 9.83984H4C3.45 9.83984 3 10.2898 3 10.8398V16.9998C3 19.9998 4.5 21.9998 8 21.9998H16C19.5 21.9998 21 19.9998 21 16.9998V10.8398C21 10.2898 20.55 9.83984 20 9.83984ZM15.66 19.5298C15.51 19.6798 15.32 19.7498 15.13 19.7498C14.94 19.7498 14.75 19.6798 14.6 19.5298L13.86 18.7898C13.28 19.1698 12.58 19.3998 11.83 19.3998C9.79 19.3998 8.13 17.7398 8.13 15.6998C8.13 13.6598 9.79 11.9998 11.83 11.9998C13.87 11.9998 15.53 13.6598 15.53 15.6998C15.53 16.4498 15.3 17.1498 14.92 17.7298L15.66 18.4698C15.95 18.7598 15.95 19.2398 15.66 19.5298Z"
			fill="#111111"
		/>
	</svg>
);
